import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInterraction } from "../../../api/axios";
import ENDPOINTS from "../../../api/endpoints";

export const analyzeMedicalInterraction = createAsyncThunk(
  "medicalInterraction/analyzeText",
  async (
    {
      patientId,
      prescriptionText,
      doctorNotes = "",
      includeArchivedDays = 30,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInterraction.post(
        ENDPOINTS.MEDICAL_INTERRACTION.ANALYZE_TEXT,
        {
          patient_id: patientId,
          prescription_text: prescriptionText,
          doctor_notes: doctorNotes,
          include_archived_days: includeArchivedDays,
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.data || error?.message || "Interraction analysis failed"
      );
    }
  }
);